const baseURL = "https://louisalleyne.github.io/email-assets/emails/static/next";

const skills = [
  { name: "AUTONOME", image: "autonome.png", alt: "Magic wand" },
  { name: "BILINGUE", image: "bilingue.png", alt: "GB and FR speech bubbles" },
  { name: "CRÉATIF", image: "creatif.png", alt: "Paintbrush" }
];

const tools = [
  [
    "python.png",
    "pandas.png",
    "jupyter.png",
    "networkx.png",
    "oracle.png",
  ],
  [
    "postgresql.png",
    "mongodb.png",
    "mysql.png",
    "neo4j.png",
  ],
  [
    "typescript.png",
    "javascript.png",
    "node.png",
    "java.png",
    "spring.png",
  ],
  [
    "react.png",
    "tailwind.png",
    "git.png",
    "docker.png",
  ],
  [
    "google_cloud.png",
    "aws.png",
    "cloudfare.png",
    "jira.png",
    "azure.png",
  ],
  [
    "spark.png",
    "hadoop.png",
    "c.png",
    "c++.png",
  ]
];

const workExperience = {
  company: "iArtisanat",
  position: "Développeur",
  begin: "Avril 2025",
  end: "Juin 2025",
  logo: "iartisanat.png",
  description: "Stage de Master 1. Développer des solutions pour automatiser et améliorer les processus de l'entreprise.",
  tasks: [
    "Développement d'un système de prospection automatisé ciblant 20 000 artisans à travers la France à l'aide de Selenium, Scikit Learn et Puppeteer.",
    "Développement d'un assistant vocal pour générer des devis et des estimations de travaux dans une conversation en utilisant Google Cloud API Speech et OpenAI API au lieu de remplir un formulaire.",
    "Développement d'un générateur de sites web pour les entreprises faisant partie d'iArtisanat qui suivent un template construit avec Vite.js, Tailwind CSS et React.js, permettant un déploiement rapide de nouveaux sites web d'artisans.",
    "Unification de leur charte graphique en réalisant un générateur de logo basé sur les couleurs de l'entreprise et différents slogans en Python."
  ]
};

const schoolPath = [
  {
    name: "Université de Poitiers",
    degree: "Licence Informatique",
    begin: "2020",
    end: "2024",
  },
  {
    name: "Université de Moncton 🇨🇦",
    degree: "Bachelor of Computer Science",
    begin: "2024",
    end: "2024",
    exchange: true,
  },
  {
    name: "La Rochelle Université",
    degree: "Master Informatique Ingénierie des Données",
    begin: "2024",
    end: "2026",
  },
];

const footerImages = [
  {
    src: `${baseURL}/email-icon.png`,
    alt: "louisalleynepro@gmail.com",
    link: "mailto:louisalleynepro@gmail.com"
  },
  {
    src: `${baseURL}/linkedin-icon.png`,
    alt: "LinkedIn Icon",
    link: "https://www.linkedin.com/in/louis-alleyne-3a2027204/"
  },
  {
    src: `${baseURL}/phone-icon.png`,
    alt: "07 88 57 29 10",
    link: "tel:+33788572910"
  }
];

function Profile({ title, name, company }) {
  return (
    <div className="flex flex-col items-center justify-center p-6">
      <h1 className="text-4xl font-bold mb-4">Louis Alleyne</h1>
      <div className="flex flex-col items-center rounded-br-3xl rounded-tl-3xl bg-[#262626] p-4 max-w-sm">
        <img 
          src={`${baseURL}/profile.jpg`}
          width="96"
          height="96"
          alt="Profile"
          className="rounded-full w-24 h-24 mx-auto cover"
        />
        <div className="flex flex-col items-center p-4">
          <h2 className="text-xl text-[#5FA8D3] font-bold mt-4 mb-0">ETUDIANT EN</h2>
          <h2 className="text-xl text-[#5FA8D3] font-bold m-0">INGÉNIERIE DES DONNÉES</h2>
          <p className="text-sm text-gray-200 text-left mt-4 mb-2 w-full">Bonjour {title} {name},</p>
          <p className="text-sm text-gray-200 rounded-lg text-justify m-0">
            Actuellement en dernière année de Master Informatique Ingénierie des Données à l'Université de La Rochelle, je recherche une alternance dans le domaine de l'informatique dès que possible.
          </p>
          <p className="text-sm text-gray-200 rounded-lg text-justify mt-2">
            Intéressé par les activités de {company}, je serais ravi de pouvoir contribuer à vos projets si une opportunité est disponible.
          </p>
        </div>
      </div>
    </div>
  );
};

function Action() {
  return (
    <div className="flex items-center justify-around bg-[#5FA8D3] w-full p-4">
      <button className="bg-[#262626] text-[#5FA8D3] font-semibold w-1/3 py-4 px-4 rounded-lg hover:bg-[#5FA8D3] hover:text-[#262626] hover:border-2 hover:border-[#262626] transition-colors cursor-pointer">
        <a href='https://www.linkedin.com/in/louis-alleyne-3a2027204/' target="_blank" rel="noopener noreferrer">
          LinkedIn
        </a>
      </button>
      <button className="bg-[#5FA8D3] border-2 border-[#262626] text-[#262626] font-semibold w-1/3 py-4 px-4 rounded-lg hover:bg-[#262626] hover:text-[#5FA8D3] transition-colors cursor-pointer">
        <a href='https://www.louisalleyne.com' target="_blank" rel="noopener noreferrer">
          Portfolio
        </a>
      </button>
    </div>
  );
};

function Skill({ skill }) {
  return (
    <div className="p-1 rounded-xl max-w-20 bg-gray-700 w-32 flex flex-col items-center justify-center gap-2">
      <img src={`${baseURL}/${skill.image}`} className="h-8 mx-auto mt-2" alt={skill.alt} />
      <p className="text-xs text-[#5FA8D3] !important font-semibold">{skill.name}</p>
    </div>
  );
};
  
function Skills({ skills }) {
  return (
    <div className="flex flex-col my-7 py-6 px-4 items-center min-w-sm w-sm rounded-2xl shadow-lg bg-[#262626]">
      <h2 className="text-2xl font-semibold text-white mx-auto">Mes atouts</h2>
      <div className="flex w-full justify-around mt-4 gap-4">
        {skills.map((skill, index) => (
          <Skill key={index} skill={skill} />
        ))}
      </div>
    </div>
  );
};

function ToolRow({ tools }) {
  return (
    <div className="flex justify-center items-center gap-4">
      {tools.map((tool, index) => (
        <div key={index} className="w-12 h-12 rounded-full bg-[#5FA8D3] flex items-center justify-center">
          <img src={`${baseURL}/${tool}`} alt={tool.split('.')[0].replace(/_/g, ' ')} className="h-6 w-6 mx-auto" />        
        </div>
      ))}
    </div>
  );
};

function Tools({ tools }) {
  return (
    <div className="flex flex-col bg-gray-100 px-4 w-full">
      <div className="flex flex-col items-center justify-center w-sm mx-auto">
        <h2 className="text-2xl font-semibold text-color1 mx-auto mt-4">Outils maîtrisés</h2>
        <div className="flex flex-col items-center justify-center my-8">
          {tools.map((toolRow, rowIndex) => (
            <ToolRow key={rowIndex} tools={toolRow} />
          ))}
        </div>
      </div>
    </div>
  );
};

function WorkExperienceBlock({ experience }) {
  return (
    <div className="flex flex-col items-center justify-center p-4 bg-[#262626] rounded-lg shadow-lg w-full mt-4">
      <div className="flex items-center justify-between w-full mb-4">
        <div className="flex flex-col">
          <h3 className="text-lg text-white text-left font-semibold m-0">{experience.position}</h3>
          <p className="text-xs text-gray-500 text-left m-0">{experience.begin} - {experience.end}</p>
        </div>
        <img
          src={`${baseURL}/${experience.logo}`}
          className="max-h-6 ml-auto"
          alt={experience.company}
        />
      </div>
      <p className="text-xs text-[#5FA8D3] text-left mt-4">{experience.description}</p>
      {experience.tasks.map((task, index) => (
        <div key={index} className="flex items-center mt-4">
          <img src={`${baseURL}/check.png`} className="h-4 w-4 mr-4" alt="✅" />
          <p className="text-justify text-xs text-white">{task}</p>
        </div>
      ))}
    </div>
  );
};

function WorkExperience({ experience }) {
  return (
    <div className="flex flex-col items-center justify-center p-6">
      <h2 className="text-2xl text-center font-semibold max-w-sm mx-auto">Dernière expérience professionnelle</h2>
      <WorkExperienceBlock experience={experience} />
    </div>
  );
};

function SchoolPathBlock({ school }) {
  return (
    <div className={`flex items-center justify-between p-4 shadow-md rounded-lg w-72 ${school.exchange ? 'bg-gray-700' : 'bg-[#262626]'}`}>
      <div className="flex flex-col items-start">
        <h3 className="text-sm text-white font-semibold m-0">{school.name}</h3>
        <p className="text-xs text-[#5FA8D3] mt-2">{school.degree}</p>
      </div>
      <div className="flex flex-col items-center pl-4 border-l border-gray-500">
        <p className={`text-xs ${school.exchange ? 'text-gray-400' : 'text-gray-200'} m-0`}>{school.begin}</p>
        <p className={`text-xs ${school.exchange ? 'text-gray-400' : 'text-gray-200'} mt-2 mb-0`}>{school.end}</p>
      </div>
    </div>
  );
};

function SchoolPath({ schools }) {
  return (
    <div className="bg-gray-100 py-6 px-4 pb-14 w-full">
      <div className="flex flex-col items-center justify-center">
        <h2 className="text-2xl font-semibold text-[#262626] mx-auto">Parcours scolaire</h2>
        <div className="flex flex-col items-center justify-center max-w-sm mt-4">
          {schools.map((school, index) => (
            <div key={index} className="flex flex-col items-center justify-center">
              <SchoolPathBlock school={school} />
              {index < schools.length - 1 && <img src={`${baseURL}/arrow${index % 2 === 0 ? '2' : '1'}.png`} className="w-12 mx-auto mt-3" alt="Arrow" />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

function Footer() {
  return (
    <div className="flex flex-col items-center justify-center bg-[#262626] p-6 w-full">
      <div className="flex items-center justify-center gap-4">
        {footerImages.map((image, index) => (
          <a key={index} href={image.link} target="_blank" rel="noopener noreferrer" className="mx-2">
            <img src={`${image.src}`} alt={image.alt} className="h-10 w-10 mx-2" />
          </a>
        ))}
      </div>
      <div className="text-xs text-[#5FA8D3] flex flex-col items-center mt-8">
        <p className="text-center">© {new Date().getFullYear()} Louis Alleyne. Tout droits réservés.</p>
        <p className="text-center">79000 Niort</p>
      </div>
    </div>
  );
}

function EmailWeb({ title, name, company }) {
  return (
    <div className="flex flex-col max-w-md items-center justify-center mx-auto">
      <Profile title={title} name={name} company={company} />
      <Action />
      <Skills skills={skills} />
      <Tools tools={tools} />
      <WorkExperience experience={workExperience} />
      <SchoolPath schools={schoolPath} />
      <Footer />
    </div>
  );
}

export default EmailWeb;